import React from 'react'

export interface PresenceContextType {
  presentEndUserIds: Set<number>
  setEndUserPresent: (id: number) => void
}

export const PresenceContext = React.createContext<PresenceContextType>({
  presentEndUserIds: new Set(),
  setEndUserPresent: () => {}
})
